import Config from './Config';

let axiosInstance = null;
let interceptorsConfigured = false;

export const getAxiosInstance = () => {
  if (!axiosInstance) {
    axiosInstance = Config();
  }
  return axiosInstance;
};

export const areInterceptorsConfigured = () => interceptorsConfigured;
export const setInterceptorsConfigured = (value) => {
  interceptorsConfigured = value;
};